/* SWAG theme behaviors — vanilla JS, no build step. */
(function () {
  "use strict";

  // Duplicate marquee content so the CSS loop is seamless.
  document.querySelectorAll(".swag-marquee__track").forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });

  // Drop countdown(s) — reads a target ISO date/time (interpreted in the merchant-selected
  // timezone offset, not the visitor's device timezone) off data-swag-countdown.
  document.querySelectorAll("[data-swag-countdown]").forEach(function (el) {
    var raw = el.dataset.swagCountdown;
    var offsetHours = parseFloat(el.dataset.countdownTzOffset || "0") || 0;
    // Parse the raw "YYYY-MM-DDTHH:MM:SS" as if it were UTC, then shift by the
    // selected timezone offset so the moment is correct for every visitor.
    var target = raw ? (Date.parse(raw + "Z") - offsetHours * 3600000) : NaN;
    var afterExpire = el.dataset.afterExpire || "text";
    var wrap = el.closest(".swag-announce__countdown-wrap");
    if (!raw || isNaN(target)) { if (wrap) wrap.style.display = "none"; else el.style.display = "none"; return; }

    var pad = function (n) { return String(n).padStart(2, "0"); };

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        if (afterExpire === "hide") {
          if (wrap) wrap.style.display = "none"; else el.style.display = "none";
          return;
        }
        el.textContent = el.dataset.expiredLabel || "LIVE NOW";
        el.classList.remove("is-glow");
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = (d > 0 ? d + "d " : "") + pad(h) + ":" + pad(m) + ":" + pad(s);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  // Product page: swap main gallery image on thumb click
  document.querySelectorAll("[data-swag-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var main = document.querySelector("[data-swag-gallery-main]");
      if (main) main.src = thumb.dataset.full || thumb.src;
    });
  });

  // Product page: variant option selection -> update hidden variant id + price via simple matching
  document.querySelectorAll("[data-swag-product-form]").forEach(function (form) {
    var variantsJson = form.querySelector("[data-swag-variants]");
    if (!variantsJson) return;
    var variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { variants = []; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector("[data-swag-price]");
    var addBtn = form.querySelector("[data-swag-add]");

    function currentOptions() {
      var opts = [];
      form.querySelectorAll("[data-swag-option]").forEach(function (group) {
        var selected = group.querySelector(".is-selected");
        opts.push(selected ? selected.dataset.value : null);
      });
      return opts;
    }

    function sync() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        if (addBtn) addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldOut;
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.labelSoldOut;
      }
    }

    form.querySelectorAll("[data-swag-option] .swag-swatch").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        btn.parentElement.querySelectorAll(".swag-swatch").forEach(function (b) { b.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        sync();
      });
    });
    sync();
  });

  // AJAX add-to-cart -> updates header cart count, refreshes + opens the cart drawer
  document.querySelectorAll("[data-swag-product-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[data-swag-add]");
      if (btn) { btn.dataset.prevLabel = btn.textContent; btn.textContent = "Adding…"; btn.disabled = true; }

      function resetBtn() {
        if (btn) {
          btn.textContent = btn.dataset.prevLabel || btn.dataset.labelAdd || "Add to cart";
          btn.disabled = false;
        }
      }

      var resetTimer = setTimeout(resetBtn, 2200);

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams([...new FormData(form)])
      })
        .then(function () {
          return window.SwagCart && typeof window.SwagCart.refresh === "function"
            ? window.SwagCart.refresh()
            : fetch("/cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (cart && typeof cart === "object") {
            document.querySelectorAll("[data-swag-cart-count]").forEach(function (el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? "flex" : "none";
            });
          }
          if (btn) { btn.textContent = "Added ✓"; }
          if (window.SwagCart && typeof window.SwagCart.open === "function") {
            window.SwagCart.open();
          } else if (document.getElementById("CartDrawer")) {
            var cartOpenBtn = document.querySelector("[data-cart-open]");
            if (cartOpenBtn) cartOpenBtn.click();
          }
          clearTimeout(resetTimer);
          setTimeout(resetBtn, 1400);
        })
        .catch(function () {
          clearTimeout(resetTimer);
          resetBtn();
          form.submit();
        });
    });
  });

  // Cart page (real <form>): quantity steppers submit the form on change.
  // Cart drawer (div, not a form): steppers call SwagCart.changeLine instead — wired below.
  document.querySelectorAll("[data-swag-qty-form]").forEach(function (form) {
    if (form.tagName !== "FORM") return;
    form.querySelectorAll("[data-swag-qty-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var input = form.querySelector('input[type="number"]');
        var delta = parseInt(btn.dataset.swagQtyStep, 10);
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        form.submit();
      });
    });
  });

  /* =========================================================
     Drawer system — sidebar, cart, search. Shared open/close
     helpers with focus handling, ESC-to-close, scroll lock.
     ========================================================= */
  function openDrawer(el, trigger) {
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add("is-open"); });
    document.body.classList.add("swag-drawer-open");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    var closeBtn = el.querySelector("[data-sidebar-close],[data-cart-close],[data-search-close]");
    if (closeBtn) closeBtn.focus();
    el.dataset.openedBy = trigger ? (trigger.getAttribute("aria-controls") || "") : "";
  }
  function closeDrawer(el, trigger) {
    if (!el) return;
    el.classList.remove("is-open");
    document.body.classList.remove("swag-drawer-open");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    setTimeout(function () { el.hidden = true; }, 320);
  }
  function wireDrawer(openSelector, panelId, closeSelector) {
    var panel = document.getElementById(panelId);
    if (!panel) return;
    document.querySelectorAll(openSelector).forEach(function (btn) {
      btn.addEventListener("click", function () { openDrawer(panel, btn); });
    });
    panel.querySelectorAll(closeSelector).forEach(function (btn) {
      btn.addEventListener("click", function () { closeDrawer(panel, document.querySelector(openSelector)); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel.classList.contains("is-open")) closeDrawer(panel, document.querySelector(openSelector));
    });
  }
  wireDrawer("[data-sidebar-open]", "SidebarDrawer", "[data-sidebar-close]");
  wireDrawer("[data-search-open]", "SearchDrawer", "[data-search-close]");
  wireDrawer("[data-cart-open]", "CartDrawer", "[data-cart-close]");

  // Focus the search input whenever the search drawer opens
  var searchOpenBtn = document.querySelector("[data-search-open]");
  var searchDrawerEl = document.getElementById("SearchDrawer");
  if (searchOpenBtn && searchDrawerEl) {
    searchOpenBtn.addEventListener("click", function () {
      var input = searchDrawerEl.querySelector("[data-search-input]");
      if (input) setTimeout(function () { input.focus(); }, 50);
    });
  }

  /* =========================================================
     Cart drawer — AJAX quantity/remove via /cart/change.js,
     re-rendered using Shopify's section-rendering API so markup
     (shipping bar, upsell, totals) always matches server state.
     ========================================================= */
  (function () {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return;
    var body = drawer.querySelector("[data-cart-drawer-body]");

    function render() {
      return fetch("/?section_id=cart-drawer")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var newBody = doc.querySelector("[data-cart-drawer-body]");
          var newFoot = doc.querySelector(".swag-drawer__foot");
          var newHead = doc.querySelector("#CartDrawer .swag-drawer__head span");
          if (newBody && body) body.innerHTML = newBody.innerHTML;
          var oldFoot = drawer.querySelector(".swag-drawer__foot");
          if (newFoot && oldFoot) oldFoot.outerHTML = newFoot.outerHTML;
          else if (newFoot && !oldFoot) drawer.querySelector(".swag-drawer__panel").insertAdjacentHTML("beforeend", newFoot.outerHTML);
          else if (!newFoot && oldFoot) oldFoot.remove();
          var head = drawer.querySelector(".swag-drawer__head span");
          if (newHead && head) head.textContent = newHead.textContent;
          bindLineEvents();
          return fetch("/cart.js").then(function (r) { return r.json(); });
        });
    }

    function changeLine(line, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function () { return render(); })
        .then(function (cart) {
          document.querySelectorAll("[data-swag-cart-count]").forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? "flex" : "none";
          });
        });
    }

    function bindLineEvents() {
      body.querySelectorAll("[data-swag-qty-form][data-line]").forEach(function (group) {
        var line = group.dataset.line;
        var input = group.querySelector("[data-qty-input]");
        group.querySelectorAll("[data-swag-qty-step]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var delta = parseInt(btn.dataset.swagQtyStep, 10);
            var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
            changeLine(line, next);
          });
        });
        input.addEventListener("change", function () {
          changeLine(line, Math.max(0, parseInt(input.value, 10) || 0));
        });
      });
      body.querySelectorAll("[data-cart-remove]").forEach(function (btn) {
        btn.addEventListener("click", function () { changeLine(btn.dataset.line, 0); });
      });
    }
    bindLineEvents();

    window.SwagCart = {
      open: function () { openDrawer(drawer, document.querySelector("[data-cart-open]")); },
      close: function () { closeDrawer(drawer, document.querySelector("[data-cart-open]")); },
      refresh: render
    };
  })();

  /* =========================================================
     Predictive search — fetches Shopify's suggest.json endpoint
     and renders lightweight product results in the search drawer.
     ========================================================= */
  (function () {
    var input = document.querySelector("[data-search-input]");
    var results = document.querySelector("[data-search-results]");
    if (!input || !results || input.dataset.predictiveEnabled !== "true") return;
    var timer;
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ""; return; }
      timer = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last")
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { results.innerHTML = '<p class="swag-search-empty">No results for &ldquo;' + q.replace(/</g, "") + '&rdquo;</p>'; return; }
            results.innerHTML = products.map(function (p) {
              var img = p.featured_image ? p.featured_image.url : "";
              return '<a class="swag-search-result" href="' + p.url + '">' +
                (img ? '<img src="' + img + '&width=120" alt="" loading="lazy">' : "") +
                '<span><span class="swag-search-result__title">' + p.title + '</span><br>' +
                '<span class="swag-search-result__price">' + p.price + '</span></span></a>';
            }).join("");
          })
          .catch(function () { results.innerHTML = ""; });
      }, 220);
    });
  })();
})();
